import { Content } from 'applications/GSP/pages/ParentHelper/components/History/components/Content';
import { NewChatButton } from 'applications/GSP/pages/ParentHelper/components/History/components/NewChatButton';
import { useDialogContext } from 'applications/GSP/pages/ParentHelper/providers/DialogProvider/hooks';
import { Dialog } from 'shared/components/Dialog';

import { Header } from './components/Header';
import { Paper } from './components/Paper';

export const HistoryMobile = () => {
  const { open, onClose } = useDialogContext();

  return (
    <Dialog open={open} onClose={onClose} PaperComponent={Paper}>
      <Header />
      <NewChatButton gutterTop={2} />
      <Content />
    </Dialog>
  );
};
